import React from "react"
import CardIcon from "~/common/components/atoms/card-icon/card-icon"
import "./services.scss"

export function Services() {
  return (
    <div className="services">
      <div className="services__container container">
        <div className="services__heading heading" id="services">
          <div className="heading__title">Services &amp; Pricing</div>
          <div className="heading__subtitle">
            Services include analytics and consulting on your specific situation and needs
          </div>
        </div>
        <div className="services__cards">
          {/* <div className="col">
						<CardIcon
							title={<span className="block-width-1">Template Kit Setup</span>}
							badge={"from $500"}
						>
							<p className="col-thin">
								We help setup a template kit (design system) for PowerPoint and Excel in
								form of a Style Guide which will include all the reusable graphics and
								guidelines for a team to produce world class documentation
							</p>
						</CardIcon>
					</div> */}
          <div className="col">
            <CardIcon
              title={
                <span className="block-width-1">
                  Custom
                  <br />
                  Templates
                </span>
              }
              badge={"from $500"}
            >
              <p>
                We can help repack your existing templates into Doxpro Asset format and distribute them via Doxpro
                assets channel. On average this work may take from 30h, depending on number of slides/sheets you want to
                include
              </p>
              <p>
                Or we can design a new template kit using our world class internal libraries and your brand artifacts
              </p>
            </CardIcon>
          </div>

          <div className="col">
            <CardIcon
              title={
                <span className="block-width-1">
                  Custom
                  <br />
                  Add-ins
                </span>
              }
              badge={"$59/h"}
            >
              <p>
                Doxpro platform contains a lot of useful tools. Nevertheless a business may require more specific
                solutions
              </p>
              <p>
                You can leverage Doxpro advanced automation platform and further extend it to cover your specific needs
                with custom add-ins
              </p>
              {/* <p>
								You will receive a custom version of Doxpro toolbar which will include
								extensions your business require.
							</p> */}
            </CardIcon>
          </div>

          <div className="col">
            <CardIcon
              title={
                <span className="block-width-1">
                  Formatting
                  <br />
                  Services
                </span>
              }
              badge={"$59/h"}
            >
              <p>
                While Doxpro tools can tremendously help in presentation layout and design there are certain situations
                when you would need assistance
              </p>
              <p>
                If you have adopted our template kits, we are pleased to offer you our expertise in formatting and
                design of presentations
              </p>
            </CardIcon>
          </div>

          {/* <div className="col">
						<CardIcon title="Training" badge={"from $1000"}>
							<p className="col-thin">
								While most Doxpro tools are easy and intuitive to use we recommend a
								fully-fledged training session which will use your company context to learn
								more about possible strategies when solving everyday problems with doxpro
								tooling
							</p>
						</CardIcon>
					</div> */}
        </div>
        <div className="col">
          <p className="training">
            While most Doxpro tools are easy and intuitive to use we recommend a <em>fully-fledged training session</em>{" "}
            which will use your company context to learn more about possible strategies when solving everyday problems
            with doxpro tooling
          </p>
        </div>
      </div>
    </div>
  )
}
